import { useTranslation } from 'react-i18next'
import { Base } from '@itsrever/design-system'
import { type ReturnsAvailableRefundMethodChangeOptionsResponse } from '@itsrever/rever-api'
import { selectableMethods } from './refund-method-options'

const { FieldRoot, FieldLabel, SelectCombobox } = Base

interface RefundMethodSelectProps {
  onUpdateRefundMethod: (method: string) => void
  value: string
  refundMethods?: ReturnsAvailableRefundMethodChangeOptionsResponse
}

export const RefundMethodSelect = ({
  onUpdateRefundMethod,
  value,
  refundMethods
}: RefundMethodSelectProps) => {
  const { t } = useTranslation()
  const methods = selectableMethods(refundMethods)
  const label = t('process_details_page.refund_method_label')

  return (
    <FieldRoot>
      <FieldLabel>{label}</FieldLabel>
      <SelectCombobox<string>
        items={methods}
        value={value || null}
        // A method is always picked: clearing the search text keeps the current one.
        onChange={(method) => {
          if (method) onUpdateRefundMethod(method)
        }}
        itemLabel={(method) => t(`refund_methods.${method}`)}
        placeholder={t('process_details_page.loading')}
        triggerLabel={label}
        disabled={refundMethods === undefined}
      />
    </FieldRoot>
  )
}
